<template>
  <div>  
    <b-modal id="modal_lopd" size="lg" class="fondo-backdrop"
        title="Acceso / RGPD" 
        content-class="shadow"
        no-close-on-backdrop no-close-on-esc hide-header-close
        button-size="sm" centered ok-title="Aceptar" cancel-title="Cancelar" ok-variant="outline-success" cancel-variant="outline-danger"
        @ok="aceptar" 
        @cancel="cancelar">

        <div class="texto-lopd p-1">
            <!-- <p class="m-1 text-left"><strong>Información</strong> </p> -->
            <table class="table table-bordered text-small">
                <tbody>
                    <tr>
                        <th scope="row"></th>
                        <td><strong>Información básica sobre Protección de Datos</strong></td>
                    </tr>
                    <tr>
                        <th scope="row">Responsable</th>
                        <td>Comisión de Fondos Sociales de Telefónica</td>
                    </tr>
                    <tr>
                        <th scope="row">Finalidad</th>
                        <td>Gestión de la reserva del viaje contratado, así como su seguimiento, documentación y facturación. Cumplimiento de obligaciones legales, contables, tributarias y administrativas.</td>
                    </tr>
                    <tr>
                        <th scope="row">Legitimación</th>
                        <td>Consentimiento del interesado, relación contractual, interés legítimo y obligación legal.</td>
                    </tr>
                    <tr>
                        <th scope="row">Destinatarios</th>
                        <td>No se cederán datos a terceros, salvo autorización expresa, obligación legal o cuando sean necesarios para la prestación del servicio de viaje.</td>
                    </tr>
                    <tr>
                        <th scope="row">Sus derechos</th>
                        <td>Acceder, rectificar y suprimir sus datos, así como a la portabilidad de estos; a la limitación u oposición a su tratamiento, a recibir una información leal y transparente, a revocar el consentimiento dado, a la conservación de sus datos, a no ser objeto de decisiones automatizadas y a reclamar ante la AEPD. como se explica
                            en la <a href="https://fondos-sociales.com/pdf/privacidad.pdf">información adicional.</a> </td>
                    </tr>
                    <tr>
                        <th scope="row">Procedencia</th>
                        <td>Datos proporcionados por el titular y/o obtenidos con su autorización para la/s finalidad/es principal/es.</td>
                    </tr>
                    <tr>
                        <th scope="row">Información adicional</th>
                        <td>Puede consultar la información adicional y detallada sobre Protección de Datos en
                            nuestra página web: <br> <a href="https://fondos-sociales.com/pdf/privacidad.pdf">
                                https://fondos-sociales.com/pdf/privacidad.pdf </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </b-modal>
  </div>
</template>

<script>

//import login from '@/views/Login.vue'

export default {
  name: 'lopdM',
  components: {
    //login,

  },

  data() {
    return {
    }
  },

  created() {
    // if (this.logueado) {
    //   this.$router.push('/');    
    // }
  },

  computed: {

  },
  methods: {
      close() {
          this.hideModal();    
          //this.$bvModal.hide(this.modal);
      },

      aceptar() {
          //alert('aceptar');
          this.$store.state.auth.lopd=true;


      },
      cancelar() {
          //alert('cancelar');
          this.$store.state.auth.lopd=false;

          this.$store.commit('login_off','Sin autorizar LOPD');
          //this.$router.push('/inicio');
      }
  }
}

</script>

<style>
    .fondo-backdrop {
        opacity:0.7 !important;
    }
    .texto-lopd {        
        font-size: 1rem;
        
        
    }


</style>
